import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ExtensionType, settings, BaseTexture, MIPMAP_MODES, ALPHA_MODES, utils, extensions } from '@pixi/core';
import { LoaderParserPriority, checkExtension, createTexture } from '@pixi/assets';
import '../parsers/index.mjs';
import { parseDDS } from '../parsers/parseDDS.mjs';
var loadDDS = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High
  },
  test: function test(url) {
    return checkExtension(url, ".dds");
  },
  load: function load(url, asset, loader) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, arrayBuffer, resources, textures;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return settings.ADAPTER.fetch(url);
          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.arrayBuffer();
          case 5:
            arrayBuffer = _context.sent;
            resources = parseDDS(arrayBuffer);
            textures = resources.map(function (resource) {
              var base = new BaseTexture(resource, _objectSpread({
                mipmap: MIPMAP_MODES.OFF,
                alphaMode: ALPHA_MODES.NO_PREMULTIPLIED_ALPHA,
                resolution: utils.getResolutionOfUrl(url)
              }, asset.data));
              return createTexture(base, loader, url);
            });
            return _context.abrupt("return", textures.length === 1 ? textures[0] : textures);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  unload: function unload(texture) {
    if (Array.isArray(texture)) {
      texture.forEach(function (t) {
        return t.destroy(true);
      });
    } else {
      texture.destroy(true);
    }
  }
};
extensions.add(loadDDS);
export { loadDDS };